import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Popconfirm, Radio } from "antd";
import { useI18n, useUpsell } from "../../../contexts";
import { LearnMoreTag } from "../../common";
import { UpsellTag } from "../../upsell";
const FormSettingsGoogleConsentModeTabContent = ()=>{
    const { __, _i } = useI18n();
    const { isPro } = useUpsell();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Google Consent Mode"),
                style: {
                    marginBottom: 10
                },
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "isGcm",
                        noStyle: true,
                        children: /*#__PURE__*/ _jsxs(Radio.Group, {
                            children: [
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    disabled: !isPro,
                                    value: true,
                                    children: __("Enabled")
                                }),
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    disabled: !isPro,
                                    value: false,
                                    children: __("Disabled")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            margin: "5px 0px 0px"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(LearnMoreTag, {
                                url: __("https://devowl.io/knowledge-base/real-cookie-banner-google-consent-mode-setup/")
                            }),
                            /*#__PURE__*/ _jsx(UpsellTag, {
                                title: __("Enable Google Consent Mode?"),
                                testDrive: true,
                                feature: "gcm",
                                assetName: __("pro-modal/gcm.png"),
                                description: __("Google Consent Mode is a standard from Google for the standardized signaling of consent purposes. This is particularly important in order to be able to collect and evaluate data collected in Google services more comprehensively.")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: __("Google Consent Mode provides standardized consent for Google services to Google. This allows you e.g. to instruct Google not to set cookies for certain services, but still to collect basic data about your website visitors using other technologies. According to Google, only aggregated and anonymized data will be collected.")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, curValues)=>prevValues.isGcm !== curValues.isGcm || prevValues.setCookiesViaManager !== curValues.setCookiesViaManager,
                children: (param)=>{
                    let { getFieldValue, setFieldsValue } = param;
                    const isGcm = getFieldValue("isGcm");
                    const setCookiesViaManager = getFieldValue("setCookiesViaManager");
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            !isGcm && new Date() <= new Date("2024-05-30") && /*#__PURE__*/ _jsx(Form.Item, {
                                wrapperCol: {
                                    offset: 6
                                },
                                style: {
                                    marginBottom: 10
                                },
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "notice notice-info inline below-h2 notice-alt",
                                    style: {
                                        margin: 0
                                    },
                                    children: /*#__PURE__*/ _jsx("p", {
                                        children: _i(__("As of March 2024, Google Consent Mode will be required as Google's response to the {{aDma}}Digital Markets Act (DMA){{/aDma}} in order to continue collecting complete data in e.g. Google Analytics, Remarketing for Google Ads or Google AdSense."), {
                                            aDma: /*#__PURE__*/ _jsx("a", {
                                                href: __("https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32019R1150"),
                                                target: "_blank",
                                                rel: "noreferrer"
                                            })
                                        })
                                    })
                                })
                            }),
                            isPro && isGcm && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Item, {
                                        label: __("Google Tag Manager integration"),
                                        required: true,
                                        children: [
                                            /*#__PURE__*/ _jsxs(Radio.Group, {
                                                value: setCookiesViaManager === "googleTagManagerWithGcm",
                                                onChange: (e)=>{
                                                    if (e.target.value && setCookiesViaManager === "googleTagManager") {
                                                    // Handled through `Popconfirm`
                                                    } else {
                                                        setFieldsValue({
                                                            setCookiesViaManager: e.target.value ? "googleTagManagerWithGcm" : "none"
                                                        });
                                                    }
                                                },
                                                children: [
                                                    setCookiesViaManager === "googleTagManager" ? /*#__PURE__*/ _jsx(Popconfirm, {
                                                        title: /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    style: {
                                                                        marginTop: 0
                                                                    },
                                                                    children: __("By activating this Google Tag Manager integration, consents will be transferred to Google Tag Manager via Google Consent Mode from now on. Please note that you have previously transferred consents to Google Tag Manager via Google Tag Manager Events. The Google Tag Manager events will no longer be transmitted after changing this setting.")
                                                                }),
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    children: _i(__("You must therefore {{a}}reconfigure the settings in your Google Tag Manager for Google Consent Mode{{/a}}!"), {
                                                                        a: /*#__PURE__*/ _jsx("a", {
                                                                            href: __("https://devowl.io/knowledge-base/real-cookie-banner-with-google-tag-manager-google-consent-mode/"),
                                                                            target: "_blank",
                                                                            rel: "noreferrer"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        cancelText: __("Cancel"),
                                                        okText: __("Activate now!"),
                                                        overlayStyle: {
                                                            maxWidth: 450
                                                        },
                                                        onConfirm: ()=>{
                                                            setFieldsValue({
                                                                setCookiesViaManager: "googleTagManagerWithGcm"
                                                            });
                                                        },
                                                        placement: "bottomLeft",
                                                        children: /*#__PURE__*/ _jsx(Radio.Button, {
                                                            value: true,
                                                            children: __("Enabled")
                                                        })
                                                    }) : /*#__PURE__*/ _jsx(Radio.Button, {
                                                        value: true,
                                                        children: __("Enabled")
                                                    }),
                                                    /*#__PURE__*/ _jsx(Radio.Button, {
                                                        value: false,
                                                        children: __("Disabled")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                style: {
                                                    margin: "5px 0px 0px"
                                                },
                                                children: /*#__PURE__*/ _jsx(LearnMoreTag, {
                                                    url: __("https://devowl.io/knowledge-base/real-cookie-banner-with-google-tag-manager-google-consent-mode/")
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "description",
                                                children: __('Do you use Google Tag Manager? If yes, please activate this option to transfer consents for all services that you obtain in your cookie banner as "Additional consent" via Google Consent Mode to the consent management of Google Tag Manager.')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Form.Item, {
                                        label: __("Show recommendations for using Google services without consent"),
                                        required: true,
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Item, {
                                                noStyle: true,
                                                name: "isGcmShowRecommandationsWithoutConsent",
                                                rules: [
                                                    {
                                                        type: "boolean",
                                                        required: true,
                                                        message: __("Please choose an option!")
                                                    }
                                                ],
                                                children: /*#__PURE__*/ _jsxs(Radio.Group, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                                            value: true,
                                                            children: __("Enabled")
                                                        }),
                                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                                            value: false,
                                                            children: __("Disabled")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                style: {
                                                    margin: "5px 0px 0px"
                                                },
                                                children: /*#__PURE__*/ _jsx(LearnMoreTag, {
                                                    url: __("https://devowl.io/knowledge-base/real-cookie-banner-google-consent-mode-setup/#data-protection-criticism-of-google-consent-mode")
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "description",
                                                children: _i(__("At its core, Google Consent Mode wants to collect more data about website visitors for you, for which Google services should also be loaded before consent has been given. In this case, Google for example prevents the setting of cookies. However, the IP address of your website operator is already transmitted to Google. If the IP address is regarded as personal data (usually common legal interpretation), this requires a legal basis in accordance with {{aGdpr}}Art. 6 GDPR{{/aGdpr}}. Apart from consent, only legitimate interest comes into question, which must be viewed critically in this case in terms of data protection law. First and foremost, you as the website operator and not Google are liable for possible data protection violations of this kind. By activating this option, Real Cookie Banner will show you as website operator, recommendations for the configuration of services which, in our legal opinion, lead to data protection violations, but which are in the interest of using Google Consent Mode. Google Consent Mode can also be used if the services are only loaded with consent."), {
                                                    aGdpr: /*#__PURE__*/ _jsx("a", {
                                                        href: __("https://gdpr-text.com/read/article-6/"),
                                                        target: "_blank",
                                                        rel: "noreferrer"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Form.Item, {
                                        label: __("Collect additional data via URL parameters"),
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Item, {
                                                noStyle: true,
                                                name: "isGcmCollectAdditionalDataViaUrlParameters",
                                                children: /*#__PURE__*/ _jsxs(Radio.Group, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                                            value: true,
                                                            children: __("Enabled")
                                                        }),
                                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                                            value: false,
                                                            children: __("Disabled")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                style: {
                                                    margin: "5px 0px 0px"
                                                },
                                                children: /*#__PURE__*/ _jsx(LearnMoreTag, {
                                                    url: __("https://devowl.io/knowledge-base/real-cookie-banner-google-consent-mode-setup/#collect-additional-data-via-url-parameters")
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "description",
                                                children: _i(__("If consent is not given for the {{code}}ad_storage{{/code}} and/or {{code}}analytics_storage{{/code}} consnt types (purposes) of Google Consent Mode, this option can be used to transfer data that is typically stored in cookies as GET parameters in internal links. This is particularly relevant if you place advertisements in Google Ads and conversion tracking should also work without consent. Please note that data can only be collected if you download the respective Google services before obtaining consent. As client IDs can be transmitted, among other things, which can be regarded as personal data, we consider this data transmission to be questionable in terms of data protection law."), {
                                                    code: /*#__PURE__*/ _jsx("code", {})
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Form.Item, {
                                        label: __("Redact ads data without consent"),
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Item, {
                                                noStyle: true,
                                                name: "isGcmRedactAdsDataWithoutConsent",
                                                children: /*#__PURE__*/ _jsxs(Radio.Group, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                                            value: true,
                                                            children: __("Enabled")
                                                        }),
                                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                                            value: false,
                                                            children: __("Disabled")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                style: {
                                                    margin: "5px 0px 0px"
                                                },
                                                children: /*#__PURE__*/ _jsx(LearnMoreTag, {
                                                    url: __("https://devowl.io/knowledge-base/real-cookie-banner-google-consent-mode-setup/#redact-ads-data-without-consent")
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "description",
                                                children: _i(__("If consent is not given for the {{code}}ad_storage{{/code}} consent type (purpose) of Google Consent Mode, no new cookies will be set for advertising purposes, except to fight fraud and spam. In addition, this option allows measurements for clicks on advertising to be routed through the domain {{code}}googleadsyndication.com{{/code}} instead of {{code}}doubleclick.net{{/code}} or {{code}}google.com{{/code}}, on which no cookies are set for advertising, and identifiers for clicks and page URLs are removed from advertising links. This enables more data protection-friendly conversion tracking with the simultaneous loss of detailed information on the attribution of target achievement."), {
                                                    code: /*#__PURE__*/ _jsx("code", {})
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Form.Item, {
                                        label: __("Naming of requested consent types in first view"),
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Item, {
                                                noStyle: true,
                                                name: "isGcmListPurposes",
                                                children: /*#__PURE__*/ _jsxs(Radio.Group, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                                            value: true,
                                                            children: __("Enabled")
                                                        }),
                                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                                            value: false,
                                                            children: __("Disabled")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                style: {
                                                    margin: "5px 0px 0px"
                                                },
                                                children: /*#__PURE__*/ _jsx(LearnMoreTag, {
                                                    url: __("https://devowl.io/knowledge-base/real-cookie-banner-google-consent-mode-setup/#naming-of-requested-consent-types-in-first-view")
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "description",
                                                children: __("The visitor to your website should be adequately informed as to which consent types (purposes) they are consenting to in accordance with Google Consent Mode. For this reason, all consent types should be listed by name in the first view of the cookie banner. This makes it easier for your website visitor to assess whether they really want to agree to all consents without visiting the individual privacy settings. ")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
export { FormSettingsGoogleConsentModeTabContent };
